/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/extra-data-field.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';

const ExtraDataFieldRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const enums: any = {
        Table: AuditEnumValues.DataSourceTableType,
        FieldType: AuditEnumValues.FieldDefinitionFieldType,
    };

    const enumMarkerByField = {
        FieldType: '_FIELD_TYPE',
    };

    const refactoredOldRecord = oldRecord
        ? {
              ...oldRecord,
              CfId: oldRecord.CfId?.$oid,
          }
        : null;
    const refactoredNewRecord = newRecord
        ? {
              ...newRecord,
              CfId: newRecord.CfId?.$oid,
          }
        : null;
    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({ oldRecord, newRecord, oldItem, newItem, field, enums, enumMarkerByField }),
    );

    return <FieldChangeGrid items={items} />;
};

export { ExtraDataFieldRecordChangeGrid };
